import React from "react";
import { connect } from "react-redux";
import { startLogin, startLoginAsGuest } from "../actions/auth";
import { Form } from "@ant-design/compatible";
import { Button, Input } from "antd";
import "@ant-design/compatible/assets/index.css";
import { Link } from "react-router-dom";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/login.scss";
import "../styles/components/button.scss";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: "",
      pass: ""
    };
  }
  startLogin = () => {
    this.props.startLogin();
  };

  onChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(() => ({ [name]: value }));
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.startLogin(this.state.user, this.state.pass);
  };

  componentDidMount() {
    if (this.props.asGuest) {
      this.props.startLoginAsGuest();
    }
  }

  render() {
    return (
      <div className="box-layout__box">
        <div className="box-left">
          <h4>Try it!</h4>
          <p>Get a free tour in updamus then decide.</p>
          <button
            className="button-guest"
            onClick={this.props.startLoginAsGuest}
          >
            Login as Guest
          </button>
        </div>
        <a href="https://updamus.com">
          <img src={Logo} alt="logo" />
        </a>
        <div className="box-layout__box__container">
          <div className="box-layout__box__header">
            <h2>
              Sign in to <strong>Up</strong>damus
            </h2>
            <p>Enter your details below</p>
          </div>
          <Form className="box-layout__form" onSubmit={this.onSubmit}>
            <div className="form-input">
              <label>Email address</label>
              <Input
                type="email"
                name="user"
                autoFocus
                placeholder="Email address"
                value={this.state.user}
                onChange={this.onChange}
                size="large"
              />
            </div>

            <div className="form-input">
              <label>Password</label>
              <Input.Password
                name="pass"
                placeholder="Password"
                value={this.state.pass}
                onChange={this.onChange}
                size="large"
              />
              <Link
                className="forget-password"
                onClick={this.changeStateToForget}
                to="/forget_pass"
              >
                Forget Password?
              </Link>
            </div>
            <div className="box-layout__other">
              <div className="login-button-container">
                <Button
                  className="button-login"
                  type="primary"
                  shape="round"
                  size="large"
                  loading={this.props.fetchInProgress}
                  htmlType="submit"
                >
                  Login
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="fancy-detour">
          <p>Don't have an account?</p>
          <Link to="/signup" className="button-guest">
            Sign up
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInProgress: state.fetchInProgress
});

const mapDispatchToProps = dispatch => ({
  startLogin: (type, user, pass) => dispatch(startLogin(type, user, pass)),
  startLoginAsGuest: () => dispatch(startLoginAsGuest())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
